<template>
  <div class="login-container">
    <!-- 背景装饰 -->
    <div class="bg-decoration">
      <div class="bg-circle-1"></div>
      <div class="bg-circle-2"></div>
      <div class="bg-circle-3"></div>
    </div>

    <div class="login-box">
      <!-- Logo 区域 -->
      <div class="login-header">
        <div class="logo-icon">
          <i class="el-icon-s-shop"></i>
        </div>
        <div class="logo-text">
          <h2>商家管理后台</h2>
          <p>智慧商业 · 数据驱动</p>
        </div>
      </div>

      <!-- 欢迎语 -->
      <div class="welcome-text">
        <h3>欢迎登录</h3>
        <p>请输入您的账号信息</p>
      </div>

      <!-- 登录表单 -->
      <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" class="login-form">
        <el-form-item prop="csn">
          <el-input 
            v-model="loginForm.csn" 
            placeholder="请输入公司编码" 
            prefix-icon="el-icon-office-building"
            clearable
          />
        </el-form-item>
        
        <el-form-item prop="username">
          <el-input 
            v-model="loginForm.username" 
            placeholder="请输入账号" 
            prefix-icon="el-icon-user"
            clearable
          />
        </el-form-item>
        
        <el-form-item prop="password">
          <el-input 
            type="password" 
            v-model="loginForm.password" 
            placeholder="请输入密码" 
            prefix-icon="el-icon-lock"
            show-password
            clearable
          />
        </el-form-item>
        
        <!-- 记住密码选项 -->
        <div class="login-options">
          <el-checkbox v-model="rememberPassword">记住密码</el-checkbox>
          <a href="#" class="forgot-password">忘记密码？</a>
        </div>
        
        <el-form-item>
          <el-button type="primary" @click="login" :loading="loading" class="login-btn">登 录</el-button>
        </el-form-item>
        
        <!-- 其他登录方式 -->
        <div class="other-login">
          <span class="line"></span>
          <span class="text">其他登录方式</span>
          <span class="line"></span>
        </div>
        
        <div class="login-icons">
          <div class="icon-item wechat">
            <i class="el-icon-wechat"></i>
            <span>微信</span>
          </div>
          <div class="icon-item qq">
            <i class="el-icon-qq"></i>
            <span>QQ</span>
          </div>
          <div class="icon-item phone">
            <i class="el-icon-phone"></i>
            <span>手机号</span>
          </div>
        </div>
      </el-form>
      
      <!-- 底部版权信息 -->
      <div class="login-footer">
        <p>© 2024 商家管理后台 | 智慧商业解决方案</p>
      </div>
    </div>
  </div>
</template>

<script>
import { hexMD5 } from '../utils/md5'

export default {
  name: "loginFrm",
  data() {
    return {
      loading: false,
      rememberPassword: false,
      loginForm: {
        csn: 'BS0001',
        username: '',
        password: '',
      },
      objArr: {},
      loginFormRules: {
        csn: [
          { required: true, message: "请输入公司编码", trigger: "blur" }
        ],
        username: [
          { required: true, message: "请输入账号", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
      },
    }
  },
  mounted() {
    this.loadSavedAccount()
  },
  methods: {
    // 加载保存的账号
    loadSavedAccount() {
      const savedAccount = localStorage.getItem('saved_account')
      if (savedAccount) {
        try {
          const account = JSON.parse(savedAccount)
          this.loginForm.csn = account.csn || 'BS0001'
          this.loginForm.username = account.username || ''
          if (account.password) {
            this.loginForm.password = account.password
          }
          this.rememberPassword = true
        } catch (e) {
          console.error('读取保存账号失败', e)
        }
      }
    },
    
    // 保存账号密码
    saveAccount() {
      if (this.rememberPassword) {
        const accountData = {
          csn: this.loginForm.csn,
          username: this.loginForm.username,
          password: this.loginForm.password
        }
        localStorage.setItem('saved_account', JSON.stringify(accountData))
      } else {
        localStorage.removeItem('saved_account')
      }
    },
    
    // 重置按钮
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields()
    },
    
    // 登录按钮
    login() {
      this.$refs.loginFormRef.validate((valid) => {
        if (valid) {
          this.loading = true
          
          // 保存账号密码
          this.saveAccount()
          
          let obj = {
            username: this.loginForm.username,
            password: hexMD5(this.loginForm.password),
            csn: this.loginForm.csn,
            appid: '20220101'
          }
          
          this.objArr = obj
          obj.sign = this.sign(this.objArr)
          
          this.$axios.getAdmin(this.objArr).then(res => {
            this.loading = false
            if (res.code == 200) {
              console.log('res.data', res.data)
              this.$message.success('登录成功')
              
              // 存储用户信息
              sessionStorage.setItem("token", res.data.token)
              sessionStorage.setItem("remark", res.data.remark)
              sessionStorage.setItem('company_id', res.data.company_id)
              sessionStorage.setItem("userName", res.data.user_name)
              sessionStorage.setItem("roles", JSON.stringify(res.data.roles))
              sessionStorage.setItem('user_id', res.data.id)
              sessionStorage.setItem('uid', res.data.id)
              
              this.$router.replace("/home")
            } else {
              this.$message.error(res.msg)
            }
          }).catch(error => {
            this.loading = false
            console.log(error)
            this.$message.error('登录失败，请检查网络')
          })
        }
      })
    },
    
    sign(unordered) {
      const secret = "37506178be498bf490e2e25b8f5ccb4d"
      const ordered = {}
      Object.keys(unordered).sort().forEach(function(key) {
        if (!Array.isArray(unordered[key])) {
          ordered[key] = unordered[key]
        }
      })
      var rs = ""
      for (var key in ordered) {
        rs += key + "=" + ordered[key] + "&"
      }
      console.log(rs + "key=" + secret)
      return hexMD5(hexMD5(rs + "key=" + secret)).toLocaleUpperCase()
    },
  },
}
</script>

<style lang="less" scoped>
.login-container {
  position: relative;
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 8%;
}

// 背景装饰动画
.bg-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
  
  .bg-circle-1 {
    position: absolute;
    top: -20%;
    left: -10%;
    width: 500px;
    height: 500px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    animation: float 20s ease-in-out infinite;
  }
  
  .bg-circle-2 {
    position: absolute;
    bottom: -15%;
    left: 20%;
    width: 400px;
    height: 400px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
    animation: float 15s ease-in-out infinite reverse;
  }
  
  .bg-circle-3 {
    position: absolute;
    top: 30%;
    right: -10%;
    width: 600px;
    height: 600px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 50%;
    animation: float 25s ease-in-out infinite;
  }
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(30px, -30px);
  }
}

// 登录卡片
.login-box {
  position: relative;
  z-index: 1;
  width: 460px;
  background: #fff;
  border-radius: 24px;
  padding: 40px 36px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-4px);
  }
}

// Logo 区域
.login-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 32px;
  
  .logo-icon {
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, #1677ff, #4096ff);
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    i {
      font-size: 28px;
      color: #fff;
    }
  }
  
  .logo-text {
    text-align: left;
    
    h2 {
      font-size: 20px;
      font-weight: 600;
      color: #1f2d3d;
      margin: 0 0 2px 0;
    }
    
    p {
      font-size: 12px;
      color: #8c8f98;
      margin: 0;
    }
  }
}

// 欢迎语
.welcome-text {
  text-align: center;
  margin-bottom: 32px;
  
  h3 {
    font-size: 28px;
    font-weight: 600;
    color: #1f2d3d;
    margin: 0 0 8px 0;
  }
  
  p {
    font-size: 14px;
    color: #8c8f98;
    margin: 0;
  }
}

// 表单样式
.login-form {
  :deep(.el-form-item) {
    margin-bottom: 24px;
  }
  
  :deep(.el-input__inner) {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    border: 1px solid #e4e7ed;
    font-size: 14px;
    transition: all 0.3s;
    
    &:focus {
      border-color: #1677ff;
      box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
    }
  }
  
  :deep(.el-input__prefix) {
    font-size: 18px;
    line-height: 48px;
    left: 14px;
    
    i {
      color: #8c8f98;
    }
  }
  
  :deep(.el-input__inner) {
    padding-left: 42px;
  }
}

// 登录选项
.login-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
  
  :deep(.el-checkbox__label) {
    font-size: 13px;
    color: #606266;
  }
  
  :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
    background-color: #1677ff;
    border-color: #1677ff;
  }
  
  .forgot-password {
    font-size: 13px;
    color: #1677ff;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
}

// 登录按钮
.login-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 24px;
  background: linear-gradient(135deg, #1677ff, #4096ff);
  border: none;
  transition: all 0.3s;
  
  &:hover {
    background: linear-gradient(135deg, #0c5fcc, #1677ff);
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(22, 119, 255, 0.3);
  }
}

// 其他登录方式
.other-login {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 28px 0 20px;
  
  .line {
    flex: 1;
    height: 1px;
    background: #e4e7ed;
  }
  
  .text {
    padding: 0 12px;
    font-size: 12px;
    color: #8c8f98;
  }
}

.login-icons {
  display: flex;
  justify-content: center;
  gap: 32px;
  margin-bottom: 32px;
  
  .icon-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    transition: all 0.3s;
    
    i {
      width: 44px;
      height: 44px;
      font-size: 24px;
      line-height: 44px;
      text-align: center;
      background: #f8f9fc;
      border-radius: 50%;
      color: #606266;
      transition: all 0.3s;
    }
    
    span {
      font-size: 12px;
      color: #8c8f98;
    }
    
    &:hover {
      transform: translateY(-3px);
      
      i {
        background: #e6f4ff;
        color: #1677ff;
      }
    }
    
    &.wechat:hover i {
      background: #2cbd2a20;
      color: #2cbd2a;
    }
    
    &.qq:hover i {
      background: #12b7f520;
      color: #12b7f5;
    }
    
    &.phone:hover i {
      background: #e6a23c20;
      color: #e6a23c;
    }
  }
}

// 底部版权
.login-footer {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  
  p {
    font-size: 11px;
    color: #c0c4cc;
    margin: 0;
  }
}

// 响应式
@media screen and (max-width: 768px) {
  .login-container {
    padding-right: 0;
    justify-content: center;
  }
  
  .login-box {
    width: 90%;
    max-width: 400px;
    padding: 30px 24px;
  }
  
  .welcome-text h3 {
    font-size: 24px;
  }
  
  .login-header .logo-icon {
    width: 40px;
    height: 40px;
    
    i {
      font-size: 22px;
    }
  }
  
  .login-header .logo-text h2 {
    font-size: 18px;
  }
}
</style>